<template>
  <div class="TopicTitle">
    <img :src="logoSrc" alt="topic title" />
    <h1>
      {{ questionsCount }} {{ getCurrentTopic.displayName }} interview
      questions.
    </h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TopicTitle',
  computed: {
    ...mapGetters(['getCurrentTopic', 'getQuestions']),
    questionsCount() {
      return this.getQuestions?.length;
    },
    logoSrc() {
      let image;
      try {
        image = require(`../assets/img/topic_logos/${this.getCurrentTopic.topicName}.svg`);
      } catch (error) {
        console.log(error);
        return;
      }
      return image;
    },
  },
};
</script>

<style lang="scss" scoped>
.TopicTitle {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid $color-light-grey;
  img {
    width: 45px;
    height: 45px;
    margin-right: 15px;
  }
  h1 {
    font-weight: 700;
    font-size: 24px;
    color: $color-black;
  }
}

@media screen and (max-width: 650px) {
  .TopicTitle {
    img {
      width: 45px;
      height: 45px;
    }
    h1 {
      font-size: 18px;
    }
  }
}
</style>
